<template>
    <div>
        <v-skeleton-loader tile v-if="isLoading && !accounts" type="table"></v-skeleton-loader>
        <v-data-table
            v-else
            :headers="headers"
            :server-items-length="rowCount"
            :itemStart="itemStart"
            :loading="isLoading"
            :items="accounts"
            item-key="account_number"
            disable-filtering
            loader-height="1"
            disable-sort
            disable-pagination
            show-select
            checkbox-color="#6B7BB2"
            v-model="selectedSync"
            hide-default-footer
            :item-class="itemRowBackground"
            no-data-text="За вами нет закрепленных домов"
        >
            <template v-slot:header.data-table-select="{ on, props }">
                <v-simple-checkbox v-ripple v-bind="props" v-on="on" dark />
            </template>

            <template v-for="(header, index) in headers" v-slot:[`header.${header.value}`]>
                <th :key="index" v-html="header.text"></th>
            </template>

            <template v-slot:item.data-table-select="{ item }">
                <td style="vertical-align: top">
                    <v-checkbox style="margin:0; padding:0" color="gray" v-model="selectedSync" :value="item" />
                </td>
            </template>

            <template v-slot:item.account_number="{ item }">
                <td style="vertical-align: top;">
                    <div class="mb-4">
                        {{ item['account_number'] }}
                    </div>
                </td>
            </template>

            <template v-slot:item.name="{ item }">
                <td style="vertical-align: top;">
                    <div class="mb-4">
                        {{ item['person_name'] }}
                    </div>
                    <div>
                        {{ item['iin'] }}
                    </div>
                </td>
            </template>

            <template v-slot:item.address="{ item }">
                <td style="vertical-align: top">
                    <div class="pb-4">
                        {{ item['address_full_name'] }}
                    </div>
                    <div class="pb-4">
                        <div>{{ item['district_name'] }}</div>
                        <div>{{ item['customer_service_center_name'] }}</div>
                    </div>
                    <div class="primaryDark--text" v-for="contact in item.contacts" :key="contact['account_contact_value']">
                        {{ contact['account_contact_value'] }}
                    </div>
                </td>
            </template>

            <template v-slot:item.meters="{ item }">
                <td style="vertical-align: top" v-if="item.meters">
                    <div>
                        {{ item.meters['meter_type_name'] }}
                    </div>
                    <div class="pb-4">
                        {{ item.meters['meter_class_name'] }}
                    </div>
                    <div>
                        {{ item.meters['meter_number'] }}
                    </div>
                    <div class="pb-4">
                        Заводской<br />
                        номер
                    </div>
                    <div>
                        {{ item.meters['date_begin'] }}
                    </div>
                    <div>
                        Дата начала <br />
                        действия
                    </div>
                </td>
            </template>

            <template v-slot:item.stateService="{ item }">
                <td style="vertical-align: top;">
                    <div :key="serv.record_id" v-for="(serv, idx) in item['serv']">
                        <div :class="{ 'pb-4': idx === 0 }">
                            <div>
                                {{ serv['serv_type_name'] }}
                            </div>
                            <div :class="serv['is_connected'] ? 'green--text' : 'red--text'">
                                {{ serv['is_connected'] ? 'Подключено' : 'Отключено' }}
                            </div>
                            <div>
                                {{ serv['action_date'] }}
                            </div>
                        </div>
                    </div>
                </td>
            </template>

            <template v-slot:item.debts="{ item }">
                <td style="vertical-align: top;">
                    <div :key="debt.record_id" v-for="(debt, idx) in item['debts_info']">
                        <div :class="{ 'pb-4': idx === 0 }">
                            <div>
                                {{ debt['sum_debt'] }}
                            </div>
                            <div>
                                {{ debt['suppl_service_group_name'] }}
                            </div>
                        </div>
                        <div v-if="item['debts_info'].length === 1">
                            <div>
                                0.00
                            </div>
                            <div>
                                Пеня
                            </div>
                        </div>
                    </div>
                </td>
            </template>

            <template v-slot:item.pre_trial_notice="{ item }">
                <td style="vertical-align: top;">
                    <div class="pb-4">
                        <div>
                            {{ item['pre_trial_notice']['status_name'] }}
                        </div>
                        <div>
                            {{ item['pre_trial_notice']['status_date'] }}
                        </div>
                        <div>
                            {{ item['pre_trial_notice']['engineer_name'] }}
                        </div>
                    </div>
                    <v-btn @click.stop="openCreateActDialog(item)" small height="64" width="177" rounded color="gray">
                        <div class=" d-flex">
                            <v-icon color="white">add</v-icon>
                            <div class="white--text text-left">
                                акт<br />
                                на подключение /<br />отключение
                            </div>
                        </div>
                    </v-btn>
                </td>
            </template>

            <template v-slot:item.pre_trial_claim="{ item }">
                <td style="vertical-align: top;">
                    <div class="pb-4">
                        <div>
                            {{ item['pre_trial_claim']['pre_trial_claim_status_name'] }}
                        </div>
                        <div>
                            {{ item['pre_trial_claim']['pre_trial_claim_delivery_date'] }}
                        </div>
                    </div>
                </td>
            </template>

            <template v-slot:footer>
                <div class="d-flex justify-end">
                    <div class="pr-8">{{ pagination }}</div>
                    <v-icon :disabled="itemStart === 0" @click="decrement" class="pointer">arrow_back_ios</v-icon>
                    <v-icon :disabled="isLastItem" @click="increment" class="pointer">arrow_forward_ios</v-icon>
                </div>
            </template>
        </v-data-table>
        <CreateAct v-model="createActDialog" :is-contract="false" :info-create-model.sync="infoCreate" />
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import translate from '@/utils/translate.util';
import CreateAct from '@/components/acts/CreateAct.vue';
import ActsService from '@/services/apiRequests/acts.service';

export default {
    name: 'AccountsDebtTable',
    components: { CreateAct },
    props: {
        isLoading: {
            type: Boolean,
            required: true
        },
        itemsPerPage: {
            type: Number,
            required: true
        },
        itemStart: {
            type: Number,
            required: true
        },
        selected: {
            required: true
        }
    },
    data: function() {
        return {
            headers: [
                {
                    text: 'Номер лицевого<br> счета',
                    value: 'account_number'
                },
                { text: 'ФИО', value: 'name' },
                { text: 'Адрес<br> Административный район<br> Контакты', value: 'address' },
                { text: 'Прибор учета', value: 'meters' },
                { text: 'Состояние<br> услуг', value: 'stateService' },
                { text: 'Сведения по<br> задолженности', value: 'debts' },
                { text: 'Досудебное<br> уведомление', value: 'pre_trial_notice' },
                { text: 'Досудебная<br> претензия', value: 'pre_trial_claim' }
            ],
            accountId: null,
            createActDialog: false,
            infoCreate: {}
        };
    },
    computed: {
        ...mapGetters('accounts', ['getRowCount', 'getAccounts']),
        rowCount() {
            return this.getRowCount;
        },
        accounts() {
            return translate(this.getAccounts, 'full', this.$i18n.locale);
        },
        pagination() {
            return `${this.itemStart + 1}-${this.isLastItem ? this.getRowCount : this.itemEnd} из ${this.getRowCount}`;
        },
        itemEnd() {
            return this.itemStart + this.itemsPerPage;
        },
        isLastItem() {
            return this.itemEnd > this.getRowCount;
        },
        selectedSync: {
            get() {
                return this.selected;
            },
            set(val) {
                this.$emit('update:selected', val);
            }
        }
    },
    methods: {
        increment() {
            this.$emit('update:itemStart', this.itemStart + this.itemsPerPage);
        },
        decrement() {
            this.$emit('update:itemStart', this.itemStart - this.itemsPerPage);
        },
        itemRowBackground: function(item) {
            return item['not_paid_notice'] ? 'status-column' : '';
        },
        async openCreateActDialog(item) {
            this.createActDialog = true;
            const infoCreate = await ActsService.getInfoCreateAccountAct(item['record_id']);
            if (!infoCreate.successfull) return;
            this.infoCreate = translate(infoCreate.data[0], 'full', this.$i18n.locale);
            this.infoCreate['account_rid'] = item['record_id'];
        }
    }
};
</script>

<style lang="scss">
.status-column {
    background-color: #ffebeb;
}
</style>
